<div class="row mt-md-2">
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.name" label="Name"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.sitz" label="Sitz"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [value]="entry.version?.rechtsform?.text | translateName"
      label="Rechtsform"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry?.version?.histInfo"
      [value]="entry.version?.personenGruppe?.text | translateName"
      label="Personengruppe"></cap-kopfdatenelement>
  </div>
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.art | translate" label="Art"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry?.mEgbpid"
      [value]="entry.egbpid"
      label="EGBPID"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [metaData]="entry?.mKantPersonId" [value]="" label="KantonalePersonenID">
      @if (entry.mKantPersonId.access !== "NONE") {
        <span>{{ entry.kantPersonId }}</span>
      } @else {
        <span>{{ "NotAvailable" | translate }}</span>
      }
    </cap-kopfdatenelement>
    <cap-kopfdatenelement [value]="entry.datenquelle | translate" label="Datenquelle"></cap-kopfdatenelement>
  </div>
</div>
